import React from 'react';
import { motion } from 'framer-motion';

const Marquee = () => {
  const capabilities = [
    '24/7/365 AOG RESPONSE',
    'NEXT-FLIGHT-OUT',
    'ONBOARD COURIER',
    'AIRCRAFT CHARTER',
    'DANGEROUS GOODS',
    'CUSTOMS CLEARANCE',
    'GLOBAL COVERAGE',
    'PHARMACEUTICAL LOGISTICS',
  ];

  return (
    <div className="marquee">
      <motion.div
        className="marquee-content"
        initial={{ x: 0 }}
        animate={{ x: '-50%' }}
        transition={{
          duration: 60,
          repeat: Infinity,
          ease: 'linear',
        }}
      >
        {[...capabilities, ...capabilities].map((item, index) => (
          <span
            key={index}
            className="inline-block px-8 text-xl md:text-2xl font-bold text-white"
          >
            {item}
            <span className="text-[#C9A227] mx-8">•</span>
          </span>
        ))}
      </motion.div>
    </div>
  );
};

export default Marquee;
